/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `VERY_CLEAN` - Very Clean
* `CLEAN` - Clean
* `AVERAGE` - Average
* `DIRTY` - Dirty
 */
export type DirtScoreEnum = typeof DirtScoreEnum[keyof typeof DirtScoreEnum];


export const DirtScoreEnum = {
  VERY_CLEAN: 'VERY_CLEAN',
  CLEAN: 'CLEAN',
  AVERAGE: 'AVERAGE',
  DIRTY: 'DIRTY',
} as const;
